import { Pipe, PipeTransform } from '@angular/core';
import { getV2ModuleData } from '../utils/module-utils';

@Pipe({
    name: 'timeTrialBannerClass',
    standalone: false
})
export class TimeTrialBannerClassPipe implements PipeTransform {
    transform(clientModule: string, showBanner: boolean): string {
        const { moduleName } = getV2ModuleData(clientModule);

        if (showBanner) {
            return `${moduleName.toLowerCase()}-time-trial-banner`;
        }

        return '';
    }
}
